// address info for all companies, etc
import Promise from 'bluebird'
import _ from 'lodash'
import api from '../../axios_api'
import {ADDRESS_CREATE, ADDRESS_DELETE, ADDRESS_FETCH, ADDRESS_UPDATE} from '../action_types'

const state = {
  address: []
}

const getters = {
  getAddress: (state) => (id) => {
    return _.find(state.address, function(o) {return o.parent === id})||{}
  }
}

const mutations = {
  initialize (state) {
    state.address = []
  },
  merge (state, payload) {
    // merge our local with what has returned
    if (_.isNil(payload) || _.isEmpty(payload)) return
    if (!_.isArray(payload)) payload = [payload]
    state.address = _.map(state.address, addr => {
      let index = _.findIndex(payload, function(a) {return a._id === addr._id})
      if (index >= 0) {
        return _.first(_.pullAt(payload, index))
      }
      return addr
    })
    if (!_.isEmpty(payload)) state.address = _.concat(state.address, payload)
    state.address = _.without(state.address, null, undefined)
  },
  remove (state, payload) {
    if (_.isNil(payload) || _.isEmpty(payload)) return
    // remove the item by the id (either _id or uaid)
    state.address = _.filter(state.address, function(a) {return a._id !== payload && a.uaid !== payload})
  }
}

const actions = {
  start ({}) {},
  stop ({}) {},
  cycle ({}) {},
  [ADDRESS_CREATE]({commit}, payload) {
    // create a new address(es), add it to our current list
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({error: 'no arguments'})
    return api.post('/address', {encrypt: {data: payload}})
    .then(res => {
      let address = res.data.encrypt.data
      // add our new address to our list
      if (!_.isNil(address) && !_.isEmpty(address)) commit('merge', address)
      return Promise.resolve(address)
    })
    .catch(err => {
      console.error(`Error during address post: ${err}`)
      return Promise.reject(err)
    })
  },
  [ADDRESS_DELETE]({commit}, payload) {
    // create a new address, add it to our current list
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({error: 'no arguments'})
    // delete the address with the given id
    return api.delete(`/address/${payload.id}`)
    .then(res => {
      // remove the id from our local address list
      commit('remove', payload.id)
      // should be 204
      return Promise.resolve()
    })
    .catch(err => {
      console.error(`Error during address delete: ${err}`)
      return Promise.reject(err)
    })
  },
  [ADDRESS_FETCH]({commit}, payload) {
    let params = {}
    if (!_.isNil(payload) && !_.isEmpty(payload)) params = _.clone(payload)
    if (_.isEmpty(params) || _.isEmpty(params.parent)) return Promise.resolve()
    return api.get('/address', {params})
    .then(res => {
      // merge returns with our data
      commit('merge', res.data.encrypt.data)
      return Promise.resolve(res.data.encrypt.data)
    })
    .catch(err => {
      console.error(`Error during address fetch: ${err}`)
      return Promise.reject(err)
    })
  },
  [ADDRESS_UPDATE]({commit}, payload) {
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({error: 'No arguments provided'})
    return api.patch('/address', {encrypt: {data: payload}})
    .then(res => {
      // merge with the data
      commit('merge', res.data.encrypt.data)
      return Promise.resolve(res.data.encrypt.data)
    })
    .catch(err => {
      console.error(`Error during address patch: ${err}`)
      return Promise.reject(err)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}